import { TextInput, useTranslate } from 'react-admin'
import FormCard from '../inputFormComponents/FormCard'
import FormRow from '../inputFormComponents/FormRow'
import { TextModelEmail } from '../GeneratedClients/FreeBillApi'
import { useState } from 'react'
import RadioButtonTextModelEmail from './RadioButtonTextModelEmail'

interface IProps {
  initConfigTextModelEmail?: "show" | "hide"
  textModelEmail?: TextModelEmail
  hideAction?: boolean
  cardNumber?: number
  description?: JSX.Element
}

const FormCardTextModelEmail = ({initConfigTextModelEmail, textModelEmail, hideAction, cardNumber, description}: IProps) => {
  const [ configTextModelEmail, setConfigTextModelEmail] = useState<"show" | "hide" | undefined>(initConfigTextModelEmail)
  const translate = useTranslate()

  const rows = [
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModelEmail.sendInvoiceEmailText" label="resources.textTemplates.sendInvoiceEmailText" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModelEmail.sendReverseInvoiceEmailText" label="resources.textTemplates.sendReverseInvoiceEmailText" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModelEmail.sendInvoiceReminderEmailTextStep1" label="resources.textTemplates.sendInvoiceReminderEmailTextStep1" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModelEmail.sendInvoiceReminderEmailTextStep2" label="resources.textTemplates.sendInvoiceReminderEmailTextStep2" />,
    ]} />,
    <FormRow fields={[
      <TextInput fullWidth multiline helperText={false} source="textModelEmail.sendInvoiceReminderEmailTextStep3" label="resources.textTemplates.sendInvoiceReminderEmailTextStep3" />,
    ]} />
  ]

  return (
    <FormCard
      cardNumber={cardNumber} 
      description={description}
      action={!hideAction ? <RadioButtonTextModelEmail setShowTextModelEmail={setConfigTextModelEmail} textModelEmail={textModelEmail} /> : undefined }
      title={translate("resources.textTemplates.name", {smart_count: 2})} 
      rows={configTextModelEmail === "show" ? rows : undefined}
    />
  )
}

export default FormCardTextModelEmail